<template>

<svg width="42" height="17" viewBox="0 0 42 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.74739 15.8601C1.32312 15.4358 0.981355 14.9055 0.757438 14.2809C0.533521 13.6563 0.392097 12.9963 0.356742 12.2774C0.297816 11.0636 0.474594 9.96754 0.898858 8.95402C1.31134 7.95229 1.92416 7.03305 2.74912 6.20809C3.9512 5.00601 5.51862 4.00427 7.45138 3.22646C9.38414 2.44864 11.5172 1.87117 13.8389 1.50583C16.1841 1.14049 18.5647 0.951929 21.0043 0.940144C23.4438 0.951929 25.8244 1.14049 28.146 1.50583C30.4559 1.88295 32.5772 2.44864 34.4746 3.21467C36.3838 3.99249 37.9513 4.99422 39.1769 6.21987C39.9783 7.02126 40.6029 7.92871 41.0272 8.91866C41.4632 9.9204 41.6753 11.0282 41.64 12.2421C41.6282 13.7388 41.1686 14.9291 40.2965 15.8012C39.9665 16.1312 39.5658 16.3904 39.1298 16.5436C38.6819 16.7086 38.1987 16.7675 37.6802 16.6733L31.0923 15.5537C30.5856 15.4712 30.1613 15.3533 29.796 15.2001C29.4424 15.0587 29.136 14.8701 28.9121 14.6462C28.6292 14.3634 28.4289 13.998 28.3228 13.562C28.205 13.1377 28.146 12.631 28.146 12.0653L28.1107 10.2386C28.1107 9.97932 28.0164 9.76719 27.8278 9.57863C27.7336 9.48435 27.6393 9.41364 27.5214 9.34293C27.3918 9.284 27.2857 9.24865 27.1914 9.20151C26.5904 9.02473 25.7183 8.88331 24.5869 8.78903C23.4438 8.70653 22.2535 8.64761 21.016 8.63582C19.755 8.64761 18.5647 8.68296 17.4098 8.77724C16.2784 8.87152 15.4181 9.02473 14.8053 9.21329C14.7228 9.24865 14.6167 9.284 14.4989 9.33114C14.3692 9.39007 14.2632 9.47257 14.1571 9.57863C13.9568 9.77898 13.8743 10.0029 13.8743 10.2622L13.8625 12.0417C13.8625 12.631 13.8036 13.1377 13.6739 13.5502C13.5679 13.9863 13.3793 14.3398 13.0847 14.6344C12.8607 14.8584 12.5779 15.0469 12.2126 15.2001C11.8472 15.3533 11.423 15.4712 10.928 15.5655L4.25762 16.6968C3.73907 16.7911 3.27945 16.7558 2.85519 16.5908C2.44271 16.414 2.07737 16.1901 1.74739 15.8601Z" fill="white"/>
</svg>

</template>

<script>
export default {
  name: 'IconBtnExit',
  components: {
  },

  data: () => {
    return {
    }
  },

  mounted () {
  },

  methods: {
  }
}
</script>
